<template>
  <div class="main_order_create_home">
    <div class="main_order_create_top" style="background-size:cover;height:270px;" :style="{backgroundImage: 'url(' + require('@/assets/banner_background.png') + ')'}">
        <div class="main_order_create_header" style="margin:0;padding:0;margin-left:2vw;margin-right:2vw;height:200px;">
            <ul style="margin:0;padding:0;padding-top:50px;">
                <li style="float:left;">
                    <div style="float:left;margin-left:20px;">
                        <img style="width:110px;height:110px;border-radius:50%;background:white;" :preview-src-list="user.thumb_url?[user.thumb_url]:[require('@/assets/avatar.png')]" :src="user.thumb_url?user.thumb_url:require('@/assets/avatar.png')"/>
                    </div>
                </li>
                <li style="float:left;">
                    <div class="user_info" style="float:left;">
                        <ul>
                            <li style="text-align: left;color:white;">
                                <span v-if="user.name" style="font-size:20px;">
                                    {{ user.name }}
                                </span>
                                <span v-else style="font-size:20px;">
                                    暂无姓名
                                </span>
                            </li>
                            <li style="margin-top:10px;text-align: left;color:white;">
                                <span v-if="user.hasOwnProperty('customer') && user.customer.identifier && (!user.hasOwnProperty('inspector') || !user.inspector.identifier)">
                                    电话: {{ user.customer.mobile }}
                                </span>
                                <span v-if="user.hasOwnProperty('inspector') && user.inspector.identifier">
                                    级别: {{ menu.inspector_level[user.inspector.level] }}
                                </span>
                                <span style="margin-left:20px;" v-if="user.hasOwnProperty('inspector') && user.inspector.identifier">
                                    编号:  {{ user.inspector.id }}
                                </span>
                            </li>
                            <li style="margin-top:10px;height:30px;">
                                <router-link to="/user/edit" style="border: 1px solid white;text-align: center;float:left;width:60px;height:30px;line-height:30px;color:white;">
                                    <img :src="require('@/assets/settings.png')" style="width:20px;height:20px;margin-bottom:3px;padding:0;" />
                                    设置
                                </router-link>
                                <a :href="urls.user.logout" style="text-align: left;line-height:30px;color:white;float:left;margin-left:20px;">
                                    安全退出
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="main_order_list_tool_bar" style="width:100%;height:8vh;margin-top:20px;">
            <div style="margin-left: 2vw;margin-right: 2vw;background:white;height:100%;border-radius:12px;border-bottom: 1px solid #999;">
                <ul style="margin:0;padding:0;width:100%;height:100%;text-align:center;display:flex;">
                    <li style="float:left;height:100%;width:20%;margin-left:2.5%;">
                        <a :style="order==0 ? {color:'#1890ff'} : {color:'#999'}" @click="undetected" style="line-height:8vh;width:100px;font-size:16px;font-weight:bold;color:#999;">
                            待检订单
                        </a>
                    </li>
                    <li style="float:left;height:100%;width:20%;margin-left:2.5%">
                        <a :style="order==1 ? {color:'#1890ff'} : {color:'#999'}" @click="detected" style="line-height:8vh;width:100px;font-size:16px;font-weight:bold;">
                            已检订单
                        </a>
                    </li>

                    <li style="float:right;height:100%;width:32%;margin-left:3%;">
                        <div style="margin-top:2vh;">
                            <router-link to="/order/create" style="border-radius:5px;line-height:30px;width:100%;height:30px;font-size:12px;background:#ff5a4f;color:white;display:block;">
                                发布检测车辆
                                <img style="width:18px;height:18px;margin-bottom:4px;" :src="require('@/assets/edit.png')" />
                            </router-link>
                        </div>
                    </li>
                    <li style="float:right;height:100%;width:20%;margin-left:2.5%;">
                        <a :style="order==999 ? {color:'#1890ff'} : {color:'#999'}" style="line-height:8vh;width:100%;font-size:20px;color:#999;" @click="searchClick">
                            搜  索
                        </a>
                        <a-modal
                        title="搜索"
                        :visible="searchModalVisible"
                        :confirm-loading="confirm_loading"
                        @ok="handleSearch"
                        @cancel="handleSearchCancel"
                        ok-text="搜索" 
                        cancel-text="取消"
                        >
                        <a-input-group compact>
                            <a-select :default-value="searchMode" style="width:30%;float:left;"  @change="handleSearchOptionChange">
                                <a-select-option value="license_plate" style="text-align:center;">
                                    车牌号
                                </a-select-option>
                                <a-select-option value="vin_no" style="text-align:center;">
                                    车架号
                                </a-select-option>
                                <a-select-option value="model" style="text-align:center;">
                                    车型
                                </a-select-option>
                            </a-select>
                            <a-input ref="search_keyword_input" style="width: 70%;float:left;" default-value="" v-model="searchKeyWord" :placeholder="searchPlaceHolder" />
                        </a-input-group>
                        </a-modal>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <a-spin tip="加载中..." style="width:100%;text-align:center;height:60px;margin-top:5vh;" :spinning="loading">
    </a-spin>
    <div class="main_order_list_content" style="overflow: hidden;">
        <ul style="display:grid;margin:0;padding:0;width:100%;">
            <a-empty
                v-if="(!order_list || order_list.length == 0) && !loading" style="width:100%;height:200px;line-height:100px;text-align:center;margin-top:15vh"
            >
                <span slot="description"> 
                    暂无内容 
                </span>
            </a-empty>
            <li v-for="(order, index) in order_list" :key="index">
                <ul style="overflow:hidden;margin:0;padding:0;width:100%;height:100%;height:40vw;margin-top:10vw;">
                    <li style="float:left;width:24vw;margin-top:3vw;">
                        <div style="width:23vw;height:23vw;">
                            <el-image fit="cover"  style="width:99.8%;height:99.8%;margin:0.1%;" :src="(order.hasOwnProperty('auto') && order.auto.hasOwnProperty('covers') && order.auto.covers.length > 0)?order.auto.covers[0].image_url:''">
                            </el-image>
                        </div>
                    </li>
                    <li style="float:left;margin-left:0px;width:50%;margin-top:0px;">
                        <ul v-if="order && order.auto" style="margin:0;padding:0;margin-left:7%;">
                            <li>
                                <span style="font-weight:bold;color:#333;">
                                    车牌号: 
                                </span>
                                <span style="font-weight:bold;color:#333;">
                                    {{ order.auto.license_plate }}
                                </span>
                            </li>
                            <li style="margin-top:4px;text-align:left;">
                                <span>
                                    车型:
                                </span>
                                <span v-if="order.auto.model">
                                    {{ order.auto.model }}
                                </span>
                                <span v-else>
                                    暂无
                                </span>
                            </li>
                            <li style="margin-top:4px;text-align:left;">
                                <span>
                                    检测类型:
                                </span>
                                <span v-if="order.menu && order.menu.name">
                                    {{ order.menu.name }}
                                </span>
                                <span v-else>
                                    暂无
                                </span>
                            </li>
                            <li style="margin-top:4px;text-align:left;">
                                <span>
                                    提交时间:
                                </span>
                                <span v-if="order.create_at">
                                    {{ order.create_at | formatDateZH }}
                                </span>
                                <span v-else>
                                    暂无
                                </span>
                            </li>
                        </ul>
                    </li>
                    <li style="float:right;float:right;" :style="{'margin-top':order.detected?'0px':'4vw'}">
                        <ul style="margin:0;padding:0;" v-if="order.detected">
                            <li v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier') && inspector_list.length > 0">
                                <a @click="asign_inspector(order)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;">
                                    指派
                                </a>
                            </li>
                            <li>
                                <a @click="report_index(order.identifier)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;margin-top:2px;" :style="{'margin-top':(!user.hasOwnProperty('inspector') || !user.inspector.hasOwnProperty('identifier') || !user.inspector.identifier)?'10vw':'2px'}">
                                    检测报告
                                </a>
                            </li>
                            <li v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                                <a @click="report_edit(order.identifier)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;margin-top:2px;">
                                    修改报告
                                </a>
                            </li>
                        </ul>
                        <ul style="margin:0;padding:0;" v-else>
                            <li v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier') && inspector_list.length > 0">
                                <a @click="asign_inspector(order)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;">
                                    指派
                                </a>
                            </li>
                            <li v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                                <a @click="report_edit(order.identifier)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;margin-top:10px;">
                                    修改报告
                                </a>
                            </li>
                            <li v-if="user.hasOwnProperty('inspector') || !user.inspector.hasOwnProperty('identifier') || !user.inspector.identifier">
                                <a @click="delete_order(order.identifier)" style="width:20vw;height:10vw;line-height:10vw;text-align:center;border-radius:5px;background:#1890ff;color:white;display:block;margin-top:10px;">
                                    删除报告
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div style="margin-left:10px;margin-right:10px;background:#eee;height:1px;margin-top:10px;">
                </div>
            </li>
            <a-spin tip="加载中..." style="width:100%;text-align:center;height:60px;margin-top:5vh;" :spinning="bottom_loading">
            </a-spin>
            <li style="width:100%;height:50px;margin-top:60px;" v-if="total_page_count > 0">
                <ul style="margin:0;padding:0;height:100%;display:flex;width:100%;">
                    <li style="float:left;min-width:7vw;">
                        <a :style="page<=1? {color:'#bbb'} : {color:'#333'}" @click="top" style="text-align:center;display:block;line-height:40px;border: 1px solid #ccc;width:100%;border-radius:4px;color:#333;">
                            &#60;&#60;
                        </a>
                    </li>

                    <li style="float:left;min-width:14vw;margin-left:5%;">
                        <a :style="page<=1? {color:'#bbb'} : {color:'#333'}" @click="prev" style="text-align:center;display:block;line-height:40px;border: 1px solid #ccc;width:100%;border-radius:4px;color:#333;">
                            上一页
                        </a>
                    </li>

                    <li style="width:20vw;margin:0 auto;">
                        <a @click="showTurnToPageModal" style="margin:0 auto;text-align:center;display:block;line-height:40px;border: 1px solid #ccc;width:100%;border-radius:4px;color:#333;">
                            {{ page }}/{{ total_page_count }}
                        </a>
                    </li>

                    <li style="float:right;width:14vw;margin-right:5%;">
                        <a :style="[page>=total_page_count? {color:'#bbb'} : {color:'#333'}]" @click="next" style="float:right;text-align:center;display:block;line-height:40px;border: 1px solid #ccc;width:100%;border-radius:4px;color:#333;">
                            下一页
                        </a>
                    </li>

                    <li style="float:right;width:7vw;">
                        <a @click="bottom" :style="[page>=total_page_count? {color:'#bbb'} : {color:'#333'}]" style="float:right;text-align:center;display:block;line-height:40px;border: 1px solid #ccc;width:100%;border-radius:4px;color:#333;">
                            &#62;&#62;
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <div style="width:100%;height:70px;margin-top:50px;text-align:center;position:relative;bottom:0;">
        <span style="line-height:70px;text-align:center;color:#323136;">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
    <a-modal
        :title="'跳转到 [ 1 - ' + String(total_page_count) + ' ] 页' "
        :visible="show_turn_to_page_modal"
        :confirm-loading="turn_confirm_loading"
        @ok="turnToPage"
        @cancel="turnToPageModalHandleCancel"
        ok-text="跳转" 
        cancel-text="取消"
        >
        <a-input-group compact>
            <a-input ref="turn_to_page_input" style="text-align:center;margin:0 auto;padding:0" default-value="" v-model="turn_to_page" type="number" :placeholder="'当前页面:'+String(page)" />
        </a-input-group>
        </a-modal>

    <a-modal
        title="请选择要指派的检测员"
        :visible="asign_inspector_modal_visible"
        :confirm-loading="asign_inspector_confirm_loading"
        @ok="handleAsignInspector"
        @cancel="handleAsignInspectorModalCancel"
        ok-text="指派"
        cancel-text="取消"
        >
        <span>
            列表显示为:  检测员名字 - 用户ID
        </span>
        <el-select 
        v-model="asign_inspector_id" 
        filterable placeholder="请选择"
        style="width: 100%"
        >
            <el-option
            style="width: 100%"
            v-for="inspector in inspector_list" 
            :key="inspector.name+' - '+inspector.identifier"
            :label="inspector.name+' - '+inspector.identifier.substr(0,30-inspector.name.length)+'...'"
            :value="inspector.identifier">
            </el-option>
        </el-select>
    </a-modal>
  </div>
</template>

<script>

import request from '../../api/request'
import urls from '../../api/urls'
import user_model from '../../model/user'
import menu_model from '../../model/menu'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'OrderList',
    head: {
        title: "个人中心",
        meta:[
            { name: 'description', content: '个人中心'}
        ]
    },
    data() {
        return {
            page: 1,
            page_count: 10,
            user: user_model,
            urls: urls,
            order_list: [
            ],
            order_list_total_count: 0,
            total_page_count: 0,
            order: 0,  // 排序， 0 => 未检测订单, 1=> 已检测订单, 3 => 搜索
            reloadOrderListKey: 0,
            searchPlaceHolder: '输入搜索关键字',
            searchModalVisible: false,
            searchMode: "license_plate",
            searchKeyWord: "",
            searchClicked:false,
            mode_choices: {
                "Primary": "初级",
                "Intermediate": "中级",
                "Advanced": "高级",
            },
            menu: menu_model,
            show_turn_to_page_modal: false,
            turn_to_page: 1,
            confirm_loading: false, 
            loading: false,
            bottom_loading: false,
            turn_confirm_loading: false, 
            company: company_model,
            inspector_list: [],
            asign_inspector_modal_visible: false,
            asign_inspector_confirm_loading: false,
            asign_order: {},
            asign_inspector_id: undefined,
        }
    },
    methods: {
        
        asign_inspector(order) {
            if (order) {
                this.asign_order = order
                this.asign_inspector_modal_visible = true
                this.asign_inspector_id = order.inspector.identifier
                console.log(this.asign_inspector_id)
            }
            else {
                this.$message.error("订单信息未请求成功，请重试")
            }
        },
        handleAsignInspector() {
            if (!this.asign_inspector_id) {
                this.$message.error("检测员未确定")
                return
            }
            console.log(this.asign_inspector_id)
            var failed_message = "指派检测师失败"
            var success_message = "指派检测师成功"
            this.asign_inspector_confirm_loading = true
            var asign_inspector_resp = request.order.asign_inspector(this.asign_order, this.asign_inspector_id)
            asign_inspector_resp.then((response) => {
                this.asign_inspector_confirm_loading = false
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    this.$message.success(success_message)
                    this.asign_inspector_modal_visible = false
                    for (let order of this.order_list) {
                        if (order.identifier == this.asign_order.identifier) {
                            for (let inspector of this.inspector_list) {
                                if (inspector.identifier == this.asign_inspector_id) {
                                    order.inspector = inspector
                                }
                            }
                        }
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.asign_inspector_confirm_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            });
            
        },
        handleAsignInspectorModalCancel() {
            this.asign_inspector_modal_visible = false;
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        fetch_inspector_list() {
            request.inspector.list().then((response) => {
        // handle success
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        var inspector_list = response.data.data
                        this.inspector_list = []
                        for (var inspector of inspector_list) {
                            console.log(inspector)
                            if (inspector && inspector.name) {
                                this.inspector_list.push(inspector)
                            }
                        }
                    }
                }
            })
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        top() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (this.page == 1) {
                return false
            }
            let page = 1

            this.bottom_loading = true
            this.fetch_order_list(page)
        },
        bottom() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (this.page == this.total_page_count) {
                return false
            }
            let page = this.total_page_count
            this.bottom_loading = true
            this.fetch_order_list(page)
            
        },
        turnToPageModalHandleCancel() {
            this.show_turn_to_page_modal = false
            this.turn_to_page = this.page
        },
        showTurnToPageModal() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (this.total_page_count <= 1) {
                return
            }
            this.turn_confirm_loading = false
            this.turn_to_page = ""
            this.show_turn_to_page_modal = true
            this.$nextTick(() => {
                this.$refs.turn_to_page_input.$refs.input.focus()
            })
            
        },
        turnToPage() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            let page = parseInt(this.turn_to_page)
            if (page > this.total_page_count || page <= 0) {
                this.$message.error("请输入 [ 1 - " + String(this.total_page_count) + " ] 的数字")
            }
            else {
                this.turn_confirm_loading = true
                this.reloadOrderListKey = 0
                this.bottom_loading = true
                this.fetch_order_list(page)
            }
        },
        handleSearchOptionChange(value) {
            this.searchMode = value
        },
        searchClick() {
            this.searchModalVisible = true
            this.searchKeyWord = ""
            this.searchMode = "license_plate"
            this.$nextTick(() => {
                this.$refs.search_keyword_input.$refs.input.focus()
            })
        },
        handleSearch() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (!this.searchKeyWord) {
                this.$message.error("请输入搜索关键字")
                return
            }
            let page = 1
            this.order = 999
            this.reloadOrderListKey = 0
            this.confirm_loading = true
            this.fetch_order_list(page)
        },
        handleSearchCancel() {
            this.searchModalVisible = false
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_inspector_list()
            this.fetch_company()
            // user_info
            this.fetch_user_info()
            // order_list
            this.loading = true
            this.fetch_order_list(this.page)
        },
        fetch_user_info() {
            var user_info_resp = request.site_user.userinfo()
            user_info_resp.then((response) => {
                var failed_message = "获取用户信息失败"
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.user = response.data.data
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        prev() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (this.page == 1) {
                return false
            }
            let page = this.page - 1
            this.bottom_loading = true
            this.fetch_order_list(page)
        },
        next() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            if (this.page == this.total_page_count) {
                return false
            }
            let page = this.page + 1
            this.bottom_loading = true
            this.fetch_order_list(page)
        },
        fetch_order_list(page) {
            
            if (page <= 0) {
                page = 1
            }
            var failed_message = "获取订单列表失败"
            var order_list_resp = undefined
            if (this.order != 999) {
                order_list_resp = request.order.list(page, this.page_count, this.order)
            }
            else {
                order_list_resp = request.search.search(page, this.page_count, this.searchKeyWord, this.searchMode)
                failed_message = "搜索失败"
            }
            this.reloadOrderListKey = 0
            order_list_resp.then((response) => {
                this.loading = false
                this.bottom_loading = false
                this.confirm_loading = false
                this.turn_confirm_loading = false
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.order_list_total_count = response.data.data.total_count
                        if (this.page_count == 0) {
                            this.total_page_count = 0
                        }
                        else {
                            this.total_page_count = this.order_list_total_count / this.page_count
                            if (this.order_list_total_count % this.page_count > 0) {
                                this.total_page_count = parseInt(this.total_page_count) + 1
                            }
                            else {
                                this.total_page_count = parseInt(this.total_page_count)
                            }
                        }
                        if (this.total_page_count == 0) {
                            this.page = 0
                        }
                        this.order_list = response.data.data.order_list
                        this.page = page
                        this.searchModalVisible = false
                        this.show_turn_to_page_modal = false
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
                this.reloadOrderListKey = 1
            })
            .catch((error) => {
                this.loading = false
                this.bottom_loading = false
                this.confirm_loading = false
                this.turn_confirm_loading = false
                this.show_turn_to_page_modal = false
                this.reloadOrderListKey = 1
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
       detected() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            this.order = 1
            let page = 1
            this.loading = true
            this.fetch_order_list(page)
        },
        undetected() {
            if (this.loading || this.bottom_loading || this.confirm_loading || this.turn_confirm_loading) {
                this.$message.warn("请在加载完成后操作...")
                return false
            }
            this.order = 0
            let page = 1
            this.loading = true
            this.fetch_order_list(page)
        },
        report_index(order_id) {
            console.log(order_id)
            if (this._isMobile()) {
                this.$router.push({
                    name: 'ReportExport',
                    query: {
                        order_id:order_id,
                    }
                });
            }
            else {
                this.$router.push({
                    name: 'ReportReport',
                    query: {
                        order_id:order_id,
                    }
                });
            }
        },
        report_edit(order_id) {
            this.$router.push({
                name: 'ReportEdit',
                query: {
                    order_id:order_id,
                }
            });
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        avatarHandleCancel() {
            this.previewVisible = false;
        },
        async avatarHandlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await this.getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        avatarHandleChange({ fileList }) {
            this.avatarList = fileList;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await this.getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
        },
        delete_order(order_id) {
            this.$confirm('确认删除该订单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var delete_resp = request.order.delete(order_id)
                var failed_message = "删除失败"
                delete_resp.then((response) => {
                    if (response.data && response.data.code == 0) {
                        this.$message.success("删除成功")
                        this.load()
                    }
                    else {
                        if (response.data && response.data.message) {
                            failed_message = response.data.message
                        }
                        this.$message.error(failed_message)
                    }
                }).catch((error) => {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    },
    created() {
        this.load()
    },
    mounted() {
        try {
            watermark.remove()
        }
        catch (err) {
            console.log()
        }
    },
    components: {

    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_edit_home {
    margin: 0;
    padding: 0;
}

.main_order_list_content {
    margin: 0;
    padding: 0;
    margin-left: 5vw;
    margin-right: 5vw;
    margin-bottom: 0;
    margin-top: 30px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
}

.edit_footer {
    background: #99999999;
    display: block;
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
}

.edit_footer span {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 50px;
}

</style>
